import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"
import fsLightbox from "fslightbox"


if (!window.customElements.get("component-artist-collection")) {
  class ArtistCollection extends HTMLElement {
    constructor() {
      super(...arguments)

      this.drawerIsOpen = false
    }

    connectedCallback() {
      this.defineElements()
      this.addListeners()
      this.initSlider()
    }

    defineElements() {
      this.$slider = this.querySelector(".artist-collection__gallery")
      this.$pagination = this.querySelector(".artist-collection__swiper-pagination")
      this.$nextSwiper = this.querySelector(".artist-collection__control--next")
      this.$prevSwiper = this.querySelector(".artist-collection__control--prev")
      this.$loadMore = this.querySelector(".artist-collection__load-more")
      this.$productList = this.querySelector(".artist-collection__product-list-wrapper")
      this.$cvButton = this.querySelector(".artist-collection__button--cv")
      this.$followButton = this.querySelector(".artist-collection__button--follow")
    }

    addListeners() {
      this.$loadMore?.addEventListener("click",
        this.onLoadMore.bind(this));
      this.$followButton?.addEventListener("click",
        this.triggerKlaviyo.bind(this))
    }

    initSlider() {
      this.swiper = new Swiper(this.$slider, {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        spaceBetween: 8,
        loop: true,
        centeredSlides: false,
        initialSlide: this.getInitialSlide(),
        pagination: {
          el: this.$pagination,
          clickable: true,
        },
        breakpoints: {
          990: {
            spaceBetween: 16,
            loop: true,
            initialSlide: this.getInitialSlide(),
            navigation: {
              nextEl: this.$nextSwiper,
              prevEl: this.$prevSwiper,
            },
          },
        },
      })
    }

    getInitialSlide() {
      const total = this.$slider.getAttribute("data-total-slides")
      return total ? Math.floor(total / 2) : 0
    }

    triggerKlaviyo(event) {

      const id = event.target.closest('button')?.getAttribute("data-klaviyo-id") || null;


      if (id) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', id]);
      }
    }

    async onLoadMore() {
      const url = this.$loadMore.getAttribute("data-next-page") || null

      if (!url) {
        return null
      }

      const { newItems, nextButton } = await this.fetchHtml(url)

      nextButton ? this.$loadMore.setAttribute("data-next-page", nextButton.getAttribute("data-next-page")) : this.$loadMore.remove()
      newItems ? newItems.forEach((item) => this.$productList?.appendChild(item)) : null

      setTimeout(() => {
        window._swat?.initializeActionButtons(".artist-collection__product-list-wrapper");
      }, 100)

    }

    async fetchHtml(url) {
      const response = await fetch(url)
      const html = await response.text()
      const parser = new DOMParser()
      const document_parsed = parser.parseFromString(html, "text/html")
      const newItems = document_parsed.querySelectorAll(".artist-collection__product")
      const nextButton = document_parsed.querySelector(".artist-collection__load-more")

      return {
        newItems,
        nextButton,
      }
    }

    customDelegate(eventName, elementSelector, handler) {
      this.addEventListener(eventName, (e) => {
        const element = e.target.closest(elementSelector);

        if (element) {
          handler.call(element, e, element);
        }
      }, false);
    };
  }

  window.customElements.define("component-artist-collection", ArtistCollection)
}
